import qs from "qs";

export const getPath = (type, slug, query) => {
  const path = `${type}/${slug}`;
  const { disease, agent } = qs.parse(query, { ignoreQueryPrefix: true });
  const filteredQuery = qs.stringify(
    { disease, agent },
    { addQueryPrefix: true }
  );

  return filteredQuery ? path + filteredQuery : path;
};
